import { gql } from 'graphql-request'

export const EXPORT_DONATION_DASHBOARD = gql`
  query ExportDonationDashboard($startDate: DateTime!, $endDate: DateTime!) {
    exportDonationDashboard(startDate: $startDate, endDate: $endDate)
  }
`
